/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef, useState, useEffect } from 'react';
import * as Yup from 'yup';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { APP_LABELS } from '@config/app-config';
import Help from '@modules/shared/components/reusable-components/help';
import TextError from '@modules/shared/components/reusable-components/text-error';
import SuccessToaster from '@modules/shared/components/reusable-components/success-toaster';
import ErrorPopup from '@modules/employee-data-collection/components/upload-file/error-popup';
import LastUpdateName from '@modules/annual-reports/components/anuual-reports-overview/last-update-name';

import {
  resetReduxState,
  postOvernightCampDataProgramAndProperty,
  getOvernightCampDataProgramAndPropertyList
} from '@redux/overnight-camp-data-program-and-property/action';
import { getCampReportsDashboardOverviewData } from '@redux/overnight-camp-data-overview/action';

import { AssociationAdminLoginDetailsSelector } from '@redux/login/selectors';
import { ApiParaSelector } from '@redux/overnight-camp-data-apiParameter/selectors';
import { OvernightCampBranchDetailsDashboardSelector } from '@redux/overnight-camp-data-report-dashboard/selectors';
import { YusaOvernightCampProgramAndPropertySelector } from '@redux/overnight-camp-data-program-and-property/selectors';

import helpicon from '@static/images/caretdoubleright.svg';

const CampProgramAndPropertyTab = props => {
  const formikref = useRef();
  const {
    status,
    setLoader,
    LoginUserData,
    ApiParameterData,
    handleResetRedux,
    getProgramAndPropertyData,
    handleGetCampReportsDashboard,
    handlePostOvernightCampDataProgramAndProperty,
    handleGetOvernightCampDataProgramAndPropertyData
  } = props;

  const role = get(LoginUserData, 'user.role[0]');

  const [help, setHelp] = useState(false);
  const [instructions, setInstructions] = useState('');
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successPopup, setSuccessPopup] = useState(false);

  const [resStatus, setResStatus] = useState();

  const initialValues = {
    isStatusOfProperty: '',
    propertyLeasedFrom: '',
    propertyLeasedFromOtherText: '',
    isConservancyTrust: '',
    isCurrentPropertyInsured: '',
    isOvernightCampProvide: [],
    isOvernightOtherDetails: '',
    isCurrentlyACAAccreditedCamp: '',
    isCurrentlyACAAccreditedCampText: ''
  };

  const getStatusOfProperty = data => {
    if (data?.IsPropertyStatusOwned) return 'owned';
    if (data?.IsPropertyStatusLeased) return 'leased';
    if (data?.IsPropertyStatusOwnedLeased) return 'owned&leased';
    return '';
  };

  const getPropertyLeasedFrom = data => {
    if (data?.IsLeasePropertyState) return 'state';
    if (data?.IsLeasePropertyFederal) return 'federal';
    if (data?.IsLeasePropertyOther) return 'other';
    return '';
  };

  const getCurrentPropertyInsured = data => {
    if (data?.IsCurrentPropertyInsuredYes) return 'yes';
    if (data?.IsCurrentPropertyInsuredNo) return 'no';
    if (data?.IsCurrentPropertyInsuredNotToAnswer) return 'preferNotAnswer';
    return '';
  };

  const getCurrentlyACAAccreditedCamp = data => {
    if (data?.IsCurrentlyACAAccreditedCampYes) return 'yes';
    if (data?.IsCurrentlyACAAccreditedCampNo) return 'no';
    if (data?.IsCurrentlyACAAccreditedCampInProgress) return 'inProgress';
    return '';
  };

  const getConservancyTrust = data => {
    if (data?.IsLandNatureConservancyYes) return 'yes';
    if (data?.IsLandNatureConservancyNo) return 'no';
    return '';
  };

  const getTrueOvernightCampKeys = data => {
    const keysToCheck = [
      'IsOvernightCampTripTravelDomestic',
      'IsOvernightCampTripTravelInternational',
      'IsOvernightTraditional',
      'IsOvernightGenderSpecific',
      'IsOvernightCoed',
      'IsOvernightTeenLeadership',
      'IsOvernightCouncellerTraining',
      'IsOvernightSpecialityCamps',
      'IsOvernightCampFamilyCamp',
      'MedicalSpecialtyCamps',
      'IsOverNightOther'
    ];

    return data && keysToCheck?.filter(key => data[key] === true);
  };

  const editValues = {
    isStatusOfProperty: getStatusOfProperty(getProgramAndPropertyData?.data),

    propertyLeasedFrom:
      getProgramAndPropertyData?.data?.IsPropertyStatusLeased ||
      getProgramAndPropertyData?.data?.IsPropertyStatusOwnedLeased
        ? getPropertyLeasedFrom(getProgramAndPropertyData?.data)
        : '',
    propertyLeasedFromOtherText: getProgramAndPropertyData?.data
      ?.IsLeasePropertyOther
      ? getProgramAndPropertyData?.data?.IsLeasePropertyOtherName
      : '',

    isConservancyTrust: getConservancyTrust(getProgramAndPropertyData?.data),

    isCurrentPropertyInsured: getCurrentPropertyInsured(
      getProgramAndPropertyData?.data
    ),

    isOvernightCampProvide: getTrueOvernightCampKeys(
      getProgramAndPropertyData?.data
    ),
    isOvernightOtherDetails: getProgramAndPropertyData?.data?.IsOverNightOther
      ? getProgramAndPropertyData?.data?.IsOverNightOtherDetails
      : '',
    isCurrentlyACAAccreditedCamp: getCurrentlyACAAccreditedCamp(
      getProgramAndPropertyData?.data
    ),
    isCurrentlyACAAccreditedCampText: getProgramAndPropertyData?.data
      ?.IsCurrentlyACAAccreditedCampNo
      ? getProgramAndPropertyData?.data
          ?.IsCurrentlyACAAccreditedCampNoWhyExplain
      : ''
  };

  const validationSchema = Yup.object({
    isStatusOfProperty: Yup.string().nullable(),
    propertyLeasedFrom: Yup.string().nullable(),
    propertyLeasedFromOtherText: Yup.string().nullable(),
    isConservancyTrust: Yup.string().nullable(),
    isCurrentPropertyInsured: Yup.string().nullable(),
    isOvernightOtherDetails: Yup.string().nullable(),
    isCurrentlyACAAccreditedCamp: Yup.string().nullable(),
    isCurrentlyACAAccreditedCampText: Yup.string().nullable()
  });

  const handleGetCall = success => {
    setLoader(true);
    handleGetOvernightCampDataProgramAndPropertyData(
      ApiParameterData?.branchNumber,
      ApiParameterData?.reportBatchId,
      ApiParameterData?.year
    ).then(res => {
      if (res && res.status === 200) {
        setLoader(false);
        if (success) {
          setSuccessPopup(true);
        }
      } else {
        setLoader(false);
        setErrorMessage(APP_LABELS.COMMON_ERROR_MESSAGE);
        setErrorPopup(true);
      }
    });
  };

  useEffect(() => {
    handleGetCall();
    setInstructions(
      JSON.parse(sessionStorage.getItem('allinstructions'))[
        'program-and-property'
      ]?.Instruction
    );
    return () => {
      handleResetRedux('YusaOvernightCampProgramAndPropertyList');
    };
  }, []);

  const handleShowHelp = () => {
    setHelp(true);
  };

  const hideShowHelp = () => {
    setHelp(false);
  };

  const onSubmit = values => {
    setLoader(true);
    const payloadBody = {
      PropertyId: getProgramAndPropertyData?.data?.PropertyId || 0,
      Year: ApiParameterData?.year,
      BranchNumber: ApiParameterData?.branchNumber,
      ReportBatchId: ApiParameterData?.reportBatchId,
      RecordStatus: getProgramAndPropertyData?.data?.RecordStatus || '',

      CreatedByPersonId: `${LoginUserData?.user?.personBranchId}`,
      UpdatedByPersonId: `${LoginUserData?.user?.personBranchId}`,

      IsPropertyStatusOwned: values?.isStatusOfProperty === 'owned',
      IsPropertyStatusLeased: values?.isStatusOfProperty === 'leased',
      IsPropertyStatusOwnedLeased:
        values?.isStatusOfProperty === 'owned&leased',

      IsLeasePropertyState: values?.propertyLeasedFrom === 'state',
      IsLeasePropertyFederal: values?.propertyLeasedFrom === 'federal',
      IsLeasePropertyOther: values?.propertyLeasedFrom === 'other',
      IsLeasePropertyOtherName:
        values?.propertyLeasedFrom === 'other'
          ? values?.propertyLeasedFromOtherText
          : '',

      IsLandNatureConservancyYes: values?.isConservancyTrust === 'yes',
      IsLandNatureConservancyNo: values?.isConservancyTrust === 'no',

      IsCurrentPropertyInsuredYes: values?.isCurrentPropertyInsured === 'yes',
      IsCurrentPropertyInsuredNo: values?.isCurrentPropertyInsured === 'no',
      IsCurrentPropertyInsuredNotToAnswer:
        values?.isCurrentPropertyInsured === 'preferNotAnswer',

      IsOvernightCampTripTravelDomestic:
        values?.isOvernightCampProvide?.includes(
          'IsOvernightCampTripTravelDomestic'
        ),
      IsOvernightCampTripTravelInternational:
        values?.isOvernightCampProvide?.includes(
          'IsOvernightCampTripTravelInternational'
        ),
      IsOvernightTraditional: values?.isOvernightCampProvide?.includes(
        'IsOvernightTraditional'
      ),
      IsOvernightCampFamilyCamp: values?.isOvernightCampProvide?.includes(
        'IsOvernightCampFamilyCamp'
      ),
      MedicalSpecialtyCamps: values?.isOvernightCampProvide?.includes(
        'MedicalSpecialtyCamps'
      ),
      IsOvernightGenderSpecific: values?.isOvernightCampProvide?.includes(
        'IsOvernightGenderSpecific'
      ),
      IsOvernightCoed:
        values?.isOvernightCampProvide?.includes('IsOvernightCoed'),
      IsOvernightTeenLeadership: values?.isOvernightCampProvide?.includes(
        'IsOvernightTeenLeadership'
      ),
      IsOvernightCouncellerTraining: values?.isOvernightCampProvide?.includes(
        'IsOvernightCouncellerTraining'
      ),
      IsOvernightSpecialityCamps: values?.isOvernightCampProvide?.includes(
        'IsOvernightSpecialityCamps'
      ),
      IsOverNightOther:
        values?.isOvernightCampProvide?.includes('IsOverNightOther'),
      IsOverNightOtherDetails: values?.isOvernightCampProvide?.includes(
        'IsOverNightOther'
      )
        ? values?.isOvernightOtherDetails
        : '',

      IsCurrentlyACAAccreditedCampYes:
        values?.isCurrentlyACAAccreditedCamp === 'yes',
      IsCurrentlyACAAccreditedCampNo:
        values?.isCurrentlyACAAccreditedCamp === 'no',
      IsCurrentlyACAAccreditedCampInProgress:
        values?.isCurrentlyACAAccreditedCamp === 'inProgress',
      IsCurrentlyACAAccreditedCampNoWhyExplain:
        values.isCurrentlyACAAccreditedCamp === 'no'
          ? values.isCurrentlyACAAccreditedCampText
          : ''
    };

    setSuccessPopup(false);
    handlePostOvernightCampDataProgramAndProperty(payloadBody).then(res => {
      if (res.status === 201 && res?.data?.isSuccess) {
        setResStatus(res.data?.RecordStatus);
        handleGetCall(true);
        handleGetCampReportsDashboard(
          ApiParameterData?.branchNumber,
          ApiParameterData?.year
        );
      } else if (res.statusCode === 409) {
        setLoader(false);
        setErrorMessage(res.errorMessage);
        setErrorPopup(true);
      } else {
        setLoader(false);
        setErrorPopup(true);
      }
    });
  };

  return (
    <>
      <Formik
        innerRef={formikref}
        initialValues={editValues || initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ values, setFieldValue, dirty }) => {
          sessionStorage.setItem('dirty', dirty);
          return (
            <Form autoComplete="off">
              <div className="ymca-completeBox ymca-overDraftView ymca-covidRelif">
                <button
                  type="button"
                  className="ymca-help-link text-decoration-none annual-report-help"
                  onClick={handleShowHelp}
                >
                  HELP
                  <img src={helpicon} className="img-fluid" alt="caret-icon" />
                </button>
                <div className="ymca-program p-1">
                  <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="YMCA-outline">
                        <h4 className="ymca-programActivities mt-0 pb-2">
                          Program and Property
                        </h4>

                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-3">
                          <div className="ymca-instructionBoxes">
                            <h4 className="ymca-instructHeadline">
                              {APP_LABELS.INSTRUCTIONS}
                            </h4>
                            <p className="ymca-instructTitle">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: instructions
                                }}
                              />
                            </p>
                          </div>
                        </div>
                        <div className="ymca-tableResponsive">
                          <table className="table ymca-table table-striped ymca-autoLength">
                            <tbody className="ymca-cuttingBody ymca-lengths">
                              <tr>
                                <td className="">
                                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="ymca-selectWrap ymca-labelling txt-mandatory ms-2">
                                      Please provide us with the status of your
                                      property.
                                    </div>
                                  </div>
                                  <div className="ymca-radioBTN d-flex">
                                    <div className="ymca-setListing me-4">
                                      <Field
                                        className="ymca-fieldRadio"
                                        type="radio"
                                        name="isStatusOfProperty"
                                        value="owned"
                                      />
                                      <span className="ymca-texting">
                                        Owned
                                      </span>
                                    </div>
                                    <div className="ymca-setListing me-4">
                                      <Field
                                        className="ymca-fieldRadio"
                                        type="radio"
                                        name="isStatusOfProperty"
                                        value="leased"
                                      />
                                      <span className="ymca-texting">
                                        Leased
                                      </span>
                                    </div>
                                    <div className="ymca-setListing me-4">
                                      <Field
                                        className="ymca-fieldRadio"
                                        type="radio"
                                        name="isStatusOfProperty"
                                        value="owned&leased"
                                      />
                                      <span className="ymca-texting">
                                        Owned & Leased
                                      </span>
                                    </div>
                                  </div>

                                  {(values.isStatusOfProperty ===
                                    'owned&leased' ||
                                    values.isStatusOfProperty === 'leased') && (
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                      <div className="ymca-selectWrap ymca-labelling txt-mandatory ms-2">
                                        Who do you lease the property from?
                                      </div>
                                      <div className="ymca-radioBTN d-flex">
                                        <div className="ymca-setListing me-4">
                                          <Field
                                            className="ymca-fieldRadio"
                                            type="radio"
                                            name="propertyLeasedFrom"
                                            value="state"
                                          />
                                          <span className="ymca-texting">
                                            State
                                          </span>
                                        </div>
                                        <div className="ymca-setListing me-4">
                                          <Field
                                            className="ymca-fieldRadio"
                                            type="radio"
                                            name="propertyLeasedFrom"
                                            value="federal"
                                          />
                                          <span className="ymca-texting">
                                            Federal
                                          </span>
                                        </div>
                                        <div className="ymca-setListing me-4">
                                          <Field
                                            className="ymca-fieldRadio"
                                            type="radio"
                                            name="propertyLeasedFrom"
                                            value="other"
                                          />
                                          <span className="ymca-texting">
                                            Other. Please Specify:
                                          </span>
                                        </div>
                                        <div className="ymca-setListing me-4">
                                          <Field
                                            name="propertyLeasedFromOtherText"
                                            type="text"
                                            maxLength="50"
                                            className={`ymca-field ${
                                              values?.propertyLeasedFrom !==
                                              'other'
                                                ? 'ymca-fieldDisabled'
                                                : ''
                                            }`}
                                            onChange={e => {
                                              setFieldValue(
                                                'propertyLeasedFromOtherText',
                                                e.target.value
                                              );
                                            }}
                                            value={
                                              values.propertyLeasedFromOtherText
                                            }
                                            disabled={
                                              values?.propertyLeasedFrom !==
                                              'other'
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </td>
                                <td className="ymca-defaultSpace">&nbsp;</td>
                              </tr>

                              <tr>
                                <td className="">
                                  <span className="txt-mandatory">
                                    Have you ever put land in a nature
                                    conservancy or trust?
                                  </span>

                                  <div className="ymca-radioBTN d-flex">
                                    <div className="ymca-setListing me-4">
                                      <Field
                                        className="ymca-fieldRadio"
                                        type="radio"
                                        name="isConservancyTrust"
                                        value="yes"
                                      />
                                      <span className="ymca-texting">Yes</span>
                                    </div>
                                    <div className="ymca-setListing me-4">
                                      <Field
                                        className="ymca-fieldRadio"
                                        type="radio"
                                        name="isConservancyTrust"
                                        value="no"
                                      />
                                      <span className="ymca-texting">No</span>
                                    </div>
                                  </div>
                                  <ErrorMessage
                                    component={TextError}
                                    name="isConservancyTrust"
                                  />
                                </td>
                              </tr>

                              <tr>
                                <td className="">
                                  <span className="txt-mandatory">
                                    Is your current property insured?
                                  </span>

                                  <div className="ymca-radioBTN d-flex">
                                    <div className="ymca-setListing me-4">
                                      <Field
                                        className="ymca-fieldRadio"
                                        type="radio"
                                        name="isCurrentPropertyInsured"
                                        value="yes"
                                      />
                                      <span className="ymca-texting">Yes</span>
                                    </div>
                                    <div className="ymca-setListing me-4">
                                      <Field
                                        className="ymca-fieldRadio"
                                        type="radio"
                                        name="isCurrentPropertyInsured"
                                        value="no"
                                      />
                                      <span className="ymca-texting">No</span>
                                    </div>
                                    <div className="ymca-setListing">
                                      <Field
                                        className="ymca-fieldRadio"
                                        type="radio"
                                        name="isCurrentPropertyInsured"
                                        value="preferNotAnswer"
                                      />
                                      <span className="ymca-texting">
                                        Prefer not to answer
                                      </span>
                                    </div>
                                  </div>
                                  <ErrorMessage
                                    component={TextError}
                                    name="isCurrentPropertyInsured"
                                  />
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <span className="txt-mandatory">
                                    What type of overnight camp experiences do
                                    you provide? (Check all that apply).
                                  </span>

                                  <div className="row">
                                    <div className="col-4">
                                      <span className="ymca-normalWrap ymca-checkboxers">
                                        <div className="d-flex ymca-listingERA">
                                          <input
                                            type="checkbox"
                                            className="ymca-checkBox"
                                          />
                                          <Field
                                            name="isOvernightCampProvide"
                                            id="IsOvernightCampTripTravelDomestic"
                                            type="checkbox"
                                            className="styled-checkbox"
                                            value="IsOvernightCampTripTravelDomestic"
                                          />
                                          <label htmlFor="IsOvernightCampTripTravelDomestic" />
                                          <span className="ymca-texting">
                                            Trip & Travel (Domestic)
                                          </span>
                                        </div>
                                      </span>

                                      <span className="ymca-normalWrap ymca-checkboxers">
                                        <div className="d-flex ymca-listingERA">
                                          <input
                                            type="checkbox"
                                            className="ymca-checkBox"
                                          />
                                          <Field
                                            name="isOvernightCampProvide"
                                            id="isOvernightCampTripTravelInternational"
                                            type="checkbox"
                                            className="styled-checkbox"
                                            value="IsOvernightCampTripTravelInternational"
                                          />
                                          <label htmlFor="IsOvernightCampTripTravelInternational" />
                                          <span className="ymca-texting">
                                            Trip & Travel (International)
                                          </span>
                                        </div>
                                      </span>

                                      <span className="ymca-normalWrap ymca-checkboxers">
                                        <div className="d-flex ymca-listingERA">
                                          <input
                                            type="checkbox"
                                            className="ymca-checkBox"
                                          />
                                          <Field
                                            name="isOvernightCampProvide"
                                            id="isOvernightCampTraditional"
                                            type="checkbox"
                                            className="styled-checkbox"
                                            value="IsOvernightTraditional"
                                          />
                                          <label htmlFor="IsOvernightTraditional" />
                                          <span className="ymca-texting">
                                            Traditional
                                          </span>
                                        </div>
                                      </span>

                                      <span className="ymca-normalWrap ymca-checkboxers">
                                        <div className="d-flex ymca-listingERA">
                                          <input
                                            type="checkbox"
                                            className="ymca-checkBox"
                                          />
                                          <Field
                                            name="isOvernightCampProvide"
                                            id="isOvernightGenderSpecific"
                                            type="checkbox"
                                            className="styled-checkbox"
                                            value="IsOvernightGenderSpecific"
                                          />
                                          <label htmlFor="IsOvernightGenderSpecific" />
                                          <span className="ymca-texting">
                                            Sex Specific
                                          </span>
                                        </div>
                                      </span>
                                    </div>

                                    <div className="col-4">
                                      <span className="ymca-normalWrap ymca-checkboxers">
                                        <div className="d-flex ymca-listingERA">
                                          <input
                                            type="checkbox"
                                            className="ymca-checkBox"
                                          />
                                          <Field
                                            name="isOvernightCampProvide"
                                            id="isOvernightCoed"
                                            type="checkbox"
                                            className="styled-checkbox"
                                            value="IsOvernightCoed"
                                          />
                                          <label htmlFor="IsOvernightCoed" />
                                          <span className="ymca-texting">
                                            Coed
                                          </span>
                                        </div>
                                      </span>

                                      <span className="ymca-normalWrap ymca-checkboxers">
                                        <div className="d-flex ymca-listingERA">
                                          <input
                                            type="checkbox"
                                            className="ymca-checkBox"
                                          />
                                          <Field
                                            name="isOvernightCampProvide"
                                            id="isOvernightTeenLeadership"
                                            type="checkbox"
                                            className="styled-checkbox"
                                            value="IsOvernightTeenLeadership"
                                          />
                                          <label htmlFor="IsOvernightTeenLeadership" />
                                          <span className="ymca-texting">
                                            Teen Leadership
                                          </span>
                                        </div>
                                      </span>

                                      <span className="ymca-normalWrap ymca-checkboxers">
                                        <div className="d-flex ymca-listingERA">
                                          <input
                                            type="checkbox"
                                            className="ymca-checkBox"
                                          />
                                          <Field
                                            name="isOvernightCampProvide"
                                            id="isOvernightCouncellerTraining"
                                            type="checkbox"
                                            className="styled-checkbox"
                                            value="IsOvernightCouncellerTraining"
                                          />
                                          <label htmlFor="IsOvernightCouncellerTraining" />
                                          <span className="ymca-texting">
                                            Counselor in Training
                                          </span>
                                        </div>
                                      </span>

                                      <span className="ymca-normalWrap ymca-checkboxers">
                                        <div className="d-flex ymca-listingERA">
                                          <input
                                            type="checkbox"
                                            className="ymca-checkBox"
                                          />
                                          <Field
                                            name="isOvernightCampProvide"
                                            id="isOvernightSpecialityCamps"
                                            type="checkbox"
                                            className="styled-checkbox"
                                            value="IsOvernightSpecialityCamps"
                                          />
                                          <label htmlFor="IsOvernightSpecialityCamps" />
                                          <span className="ymca-texting">
                                            Specialty Camps (Arts, Sports)
                                          </span>
                                        </div>
                                      </span>
                                    </div>

                                    <div className="col-4">
                                      <span className="ymca-normalWrap ymca-checkboxers">
                                        <div className="d-flex ymca-listingERA">
                                          <input
                                            type="checkbox"
                                            className="ymca-checkBox"
                                          />
                                          <Field
                                            name="isOvernightCampProvide"
                                            id="isOvernightFamilyCamps"
                                            type="checkbox"
                                            className="styled-checkbox"
                                            value="IsOvernightCampFamilyCamp"
                                          />
                                          <label htmlFor="IsOvernightCampFamilyCamp" />
                                          <span className="ymca-texting">
                                            Family Camps
                                          </span>
                                        </div>
                                      </span>

                                      <span className="ymca-normalWrap ymca-checkboxers">
                                        <div className="d-flex ymca-listingERA">
                                          <input
                                            type="checkbox"
                                            className="ymca-checkBox"
                                          />
                                          <Field
                                            name="isOvernightCampProvide"
                                            id="MedicalSpecialtyCamps"
                                            type="checkbox"
                                            className="styled-checkbox"
                                            value="MedicalSpecialtyCamps"
                                          />
                                          <label htmlFor="MedicalSpecialtyCamps" />
                                          <span className="ymca-texting">
                                            Medical Specialty Camps (Asthma,
                                            Diabetes, etc).
                                          </span>
                                        </div>
                                      </span>

                                      <span className="ymca-normalWrap ymca-checkboxers">
                                        <div className="d-flex ymca-listingERA">
                                          <input
                                            type="checkbox"
                                            className="ymca-checkBox"
                                          />
                                          <Field
                                            name="isOvernightCampProvide"
                                            id="IsOverNightOther"
                                            type="checkbox"
                                            className="styled-checkbox"
                                            value="IsOverNightOther"
                                          />
                                          <label htmlFor="IsOverNightOther" />
                                          <span className="ymca-texting">
                                            Other: Please specify text box
                                          </span>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-6">
                                      <Field
                                        as="textarea"
                                        name="isOvernightOtherDetails"
                                        maxLength={1000}
                                        className={`ymca-areaTextWidth ymca-70 ymca-nomarginAreas ${
                                          values?.isOvernightCampProvide?.includes(
                                            'IsOverNightOther'
                                          )
                                            ? ''
                                            : 'ymca-fieldDisabled'
                                        }`}
                                        disabled={
                                          !values?.isOvernightCampProvide?.includes(
                                            'IsOverNightOther'
                                          )
                                        }
                                      />
                                      <ErrorMessage
                                        component={TextError}
                                        name="fullTime"
                                      />
                                    </div>
                                  </div>
                                </td>
                                <td className="ymca-defaultSpace">&nbsp;</td>
                              </tr>

                              <tr>
                                <td>
                                  <span className="txt-mandatory">
                                    Are you currently an ACA accredited camp?
                                  </span>

                                  <div className="ymca-radioBTN d-flex">
                                    <div className="ymca-setListing me-4">
                                      <Field
                                        className="ymca-fieldRadio"
                                        type="radio"
                                        name="isCurrentlyACAAccreditedCamp"
                                        value="yes"
                                      />
                                      <span className="ymca-texting">Yes</span>
                                    </div>
                                    <div className="ymca-setListing  me-4">
                                      <Field
                                        className="ymca-fieldRadio"
                                        type="radio"
                                        name="isCurrentlyACAAccreditedCamp"
                                        value="inProgress"
                                      />
                                      <span className="ymca-texting">
                                        In-Progress
                                      </span>
                                    </div>
                                    <div className="ymca-setListing me-4">
                                      <Field
                                        className="ymca-fieldRadio"
                                        type="radio"
                                        name="isCurrentlyACAAccreditedCamp"
                                        value="no"
                                      />
                                      <span className="ymca-texting">
                                        No. Please explain why:
                                      </span>
                                    </div>
                                    <div className="ymca-setListing me-4">
                                      <Field
                                        name="isCurrentlyACAAccreditedCampText"
                                        type="text"
                                        maxLength="50"
                                        className={`ymca-field ${
                                          values?.isCurrentlyACAAccreditedCamp !==
                                          'no'
                                            ? 'ymca-fieldDisabled'
                                            : ''
                                        }`}
                                        onChange={e => {
                                          setFieldValue(
                                            'isCurrentlyACAAccreditedCampText',
                                            e.target.value
                                          );
                                        }}
                                        value={
                                          values.isCurrentlyACAAccreditedCampText
                                        }
                                        disabled={
                                          values?.isCurrentlyACAAccreditedCamp !==
                                          'no'
                                        }
                                      />
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ymca-submitHighlighter">
                  <LastUpdateName
                    Username={getProgramAndPropertyData?.data?.UpdatedByName}
                    Time={getProgramAndPropertyData?.data?.UpdatedDatetime}
                  />
                </div>
              </div>
              {role !== APP_LABELS.YUSA_DATA_VIEWER && (
                <button
                  type="submit"
                  className="btn ymca-savingBTN ymca-btnRightUntitled float-end mt-3"
                  disabled={
                    status?.toUpperCase() === APP_LABELS.STATUS_SUBMITTED
                  }
                >
                  Save
                </button>
              )}
            </Form>
          );
        }}
      </Formik>
      {successPopup && <SuccessToaster Status={resStatus} />}

      <ErrorPopup
        handleCloseErrorPopup={() => {
          setErrorPopup(false);
        }}
        errorMessage={errorMessage}
        showErrorPopup={errorPopup}
      />
      {help && (
        <Help hidePopup={hideShowHelp} keyValue="program-and-property" />
      )}
    </>
  );
};

CampProgramAndPropertyTab.propTypes = {
  setLoader: PropTypes.func.isRequired,
  handleResetRedux: PropTypes.func.isRequired,
  handleGetCampReportsDashboard: PropTypes.func.isRequired,
  handlePostOvernightCampDataProgramAndProperty: PropTypes.func.isRequired,
  handleGetOvernightCampDataProgramAndPropertyData: PropTypes.func.isRequired,

  status: PropTypes.objectOf(PropTypes.any).isRequired,
  LoginUserData: PropTypes.objectOf(PropTypes.any).isRequired,
  ApiParameterData: PropTypes.objectOf(PropTypes.any).isRequired,
  getProgramAndPropertyData: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapDispatchToProps = {
  handleResetRedux: resetReduxState,
  handleGetOvernightCampDataProgramAndPropertyData:
    getOvernightCampDataProgramAndPropertyList,
  handleGetCampReportsDashboard: getCampReportsDashboardOverviewData,
  handlePostOvernightCampDataProgramAndProperty:
    postOvernightCampDataProgramAndProperty
};

const mapStateToProps = state => ({
  ApiParameterData: ApiParaSelector(state),
  LoginUserData: AssociationAdminLoginDetailsSelector(state),
  getProgramAndPropertyData: YusaOvernightCampProgramAndPropertySelector(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(CampProgramAndPropertyTab));
